module.exports = __webpack_public_path__ + "components/bookings-online-payment-method/static/mastercard-0ddb6c3ee6971d92ac0b10fb39f80903.svg";